import React from 'react';
import { useParams, Link } from 'react-router-dom';
import ServiceDashboard from '../Templates/ServiceDashboard';
import Pruebas from '../Templates/Pruebas';
import GarantiaWidget from '../Templates/GarantiaWidget';
import Testimonios from '../Templates/Testimonios';

//PARCIALES
const MetodologiaParciales = () => {
  return (
    <div className="space-y-12 animate-fadeIn text-slate-800">
      
      {/* Encabezado Principal */}
      <div className="text-center">
        <h3 className="text-2xl md:text-3xl font-black text-slate-900 tracking-tight">
          Metodología de Pago
        </h3>
        <p className="text-slate-500 text-sm md:text-base mt-1.5 font-medium">
          Ofrecemos opciones flexibles de pago para adaptarnos a tus necesidades
        </p>
      </div>

      {/* Grid de las dos opciones de pago */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        
        {/* Tarjeta 1: Pago Completo */}
        <div className="bg-white border border-emerald-100 rounded-3xl p-6 md:p-8 text-left flex flex-col justify-between shadow-sm hover:shadow-md transition-shadow relative">
          <div className="space-y-5">
            {/* Header de Tarjeta */}
            <div className="flex items-center gap-3">
              <span className="w-7 h-7 rounded-full bg-emerald-500 text-white font-black text-sm flex items-center justify-center shadow-sm">
                1
              </span>
              <h4 className="font-black text-emerald-600 text-lg tracking-tight">
                Pago Completo
              </h4>
            </div>

            {/* Listado de Características */}
            <div className="space-y-3.5 text-slate-600 text-xs md:text-sm font-semibold">
              <div className="flex items-start gap-2.5">
                <svg className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 014.875 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0114.625 9.375v-4.5z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 13.5v6.25m3.125-3.125h-6.25" />
                </svg>
                <span>Pagas la totalidad antes del parcial</span>
              </div>
              <div className="flex items-start gap-2.5 text-slate-500/90 font-medium">
                <svg className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751A11.956 11.956 0 0112 2.714z" />
                </svg>
                <span>Obligatorio para exámenes presenciales - 100% del pago antes del examen</span>
              </div>
            </div>
          </div>

          {/* Badge verde inferior */}
          <div className="mt-6 bg-emerald-50 text-emerald-700 font-extrabold text-xs p-3.5 rounded-xl border border-emerald-100/70 flex items-center gap-2">
            <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
            Mayor seguridad y tranquilidad
          </div>
        </div>

        {/* Tarjeta 2: Pago Dividido */}
        <div className="bg-white border border-blue-100 rounded-3xl p-6 md:p-8 text-left flex flex-col justify-between shadow-sm hover:shadow-md transition-shadow relative">
          <div className="space-y-5">
            {/* Header de Tarjeta */}
            <div className="flex items-center gap-3">
              <span className="w-7 h-7 rounded-full bg-blue-600 text-white font-black text-sm flex items-center justify-center shadow-sm">
                2
              </span>
              <h4 className="font-black text-blue-800 text-lg tracking-tight">
                Pago Dividido
              </h4>
            </div>

            {/* Listado de Características */}
            <div className="space-y-3.5 text-slate-600 text-xs md:text-sm font-semibold">
              <div className="flex items-start gap-2.5">
                <svg className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                </svg>
                <span>50% antes + 50% durante la prueba</span>
              </div>
              <div className="flex items-start gap-2.5 font-medium">
                <svg className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Al enviar la mitad del parcial, el tutor cobra el resto del pago</span>
              </div>
            </div>
          </div>

          {/* Badge azul de ejemplo inferior */}
          <div className="mt-6 bg-blue-50 text-blue-700 font-medium text-xs p-3.5 rounded-xl border border-blue-100 flex items-start gap-2">
            <svg className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
            </svg>
            <div>
              <span className="font-black uppercase text-[10px] text-blue-800 tracking-wider block mb-0.5">Ejemplo:</span>
              Prueba de 2 horas, 10 preguntas = Pago del resto a la mitad del examen
            </div>
          </div>
        </div>

      </div>

      {/* Bloque de Flujo: Metodología para resolver tu parcial */}
      <div className="bg-white border border-slate-200/60 rounded-3xl p-6 md:p-8 shadow-sm max-w-5xl mx-auto">
        <div className="flex items-center justify-center gap-2 mb-8 border-b border-slate-100 pb-4">
          <svg className="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
          </svg>
          <h4 className="font-black text-slate-900 text-base md:text-lg tracking-tight">
            Metodología para Resolver tu Parcial
          </h4>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
          {/* Nodo 1 */}
          <div className="flex flex-col items-center space-y-2">
            <div className="w-11 h-11 rounded-full bg-purple-50 border border-purple-100 text-purple-600 flex items-center justify-center shadow-inner">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
            </div>
            <h5 className="font-extrabold text-slate-800 text-sm md:text-base tracking-tight">Grupo de WhatsApp</h5>
            <p className="text-xs text-slate-500 font-semibold px-2 leading-relaxed">Creamos un grupo exclusivo contigo y tu tutor especializado</p>
          </div>

          {/* Nodo 2 */}
          <div className="flex flex-col items-center space-y-2">
            <div className="w-11 h-11 rounded-full bg-emerald-50 border border-emerald-100 text-emerald-600 flex items-center justify-center shadow-inner">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h5 className="font-extrabold text-slate-800 text-sm md:text-base tracking-tight">Creación del Grupo</h5>
            <p className="text-xs text-slate-500 font-semibold px-2 leading-relaxed">Un día antes de tu prueba, entre 10:30pm - 11:30pm</p>
          </div>

          {/* Nodo 3 */}
          <div className="flex flex-col items-center space-y-2">
            <div className="w-11 h-11 rounded-full bg-blue-50 border border-blue-100 text-blue-600 flex items-center justify-center shadow-inner">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
              </svg>
            </div>
            <h5 className="font-extrabold text-slate-800 text-sm md:text-base tracking-tight">Comunicación Directa</h5>
            <p className="text-xs text-slate-500 font-semibold px-2 leading-relaxed">Resuelve dudas y problemas directamente con tu profesor</p>
          </div>
        </div>
      </div>

    </div>
  );
};
const condicionesParciales = [
  {
    num: "1",
    title: "Examen Presencial - Imposibilidad de Envío",
    desc: "Si el examen es presencial y no puedes enviarnos las preguntas al momento de rendirlo",
    alert: "Reembolso del 50% del valor - El 50% restante será cobrado",
    theme: "bg-red-50 border-red-100 text-red-800",
    circle: "bg-red-500",
    alertBox: "bg-red-100/50 border-red-200 text-red-700"
  },
  {
    num: "2",
    title: "Cancelación con Más de 24 Horas",
    desc: "Si cancelas tu examen con más de 24 horas de anticipación",
    alert: "Reembolso del 80% del costo total",
    theme: "bg-emerald-50 border-emerald-100 text-emerald-800",
    circle: "bg-emerald-500",
    alertBox: "bg-emerald-100/50 border-emerald-200 text-emerald-700"
  },
  {
    num: "3",
    title: "Cancelación con Menos de 24 Horas",
    desc: "En caso de cancelar con menos de 24 horas de anticipación",
    alert: "Reembolso del 50% - Se cobrará el resto",
    theme: "bg-orange-50 border-orange-100 text-orange-800",
    circle: "bg-orange-500",
    alertBox: "bg-orange-100/50 border-orange-200 text-orange-700"
  },
  {
    num: "4",
    title: "Reprogramación de Examen",
    desc: "Si deseas reprogramar tu examen para otra fecha",
    alert: "Multa del 20% sobre el costo total",
    theme: "bg-blue-50 border-blue-100 text-blue-800",
    circle: "bg-blue-500",
    alertBox: "bg-blue-100/50 border-blue-200 text-blue-700"
  }
];


//TALLERES
const MetodologiaTrabajos = () => {
  return (
    <div className="space-y-12 animate-fadeIn text-slate-800 font-sans">
      
      {/* 1. ENCABEZADO PRINCIPAL */}
      <div className="text-center">
        <h3 className="text-2xl md:text-3xl font-black text-slate-900 tracking-tight uppercase">
          Metodología de Pago y Trabajo
        </h3>
        <p className="text-slate-500 text-sm md:text-base mt-1.5 font-medium">
          Ofrecemos opciones flexibles y un proceso transparente para el desarrollo de tus escritos
        </p>
      </div>

      {/* 2. GRID DE LAS DOS OPCIONES DE PAGO */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
        
        {/* Tarjeta 1: Pago Completo */}
        <div className="bg-white border border-emerald-100 rounded-3xl p-6 md:p-8 text-left flex flex-col justify-between shadow-sm hover:shadow-md transition-shadow relative">
          <div className="space-y-5">
            {/* Header de Tarjeta */}
            <div className="flex items-center gap-3">
              <span className="w-7 h-7 rounded-full bg-emerald-500 text-white font-black text-sm flex items-center justify-center shadow-sm">
                1
              </span>
              <h4 className="font-black text-emerald-600 text-lg tracking-tight">
                Pago Completo (100%)
              </h4>
            </div>

            {/* Listado de Características */}
            <div className="space-y-3.5 text-slate-600 text-xs md:text-sm font-semibold">
              <div className="flex items-start gap-2.5">
                <svg className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 014.875 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0114.625 9.375v-4.5z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 13.5v6.25m3.125-3.125h-6.25" />
                </svg>
                <span>Liquidación total anticipada de tu entrega</span>
              </div>
              <div className="flex items-start gap-2.5 text-slate-500/90 font-medium">
                <svg className="w-4 h-4 text-emerald-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751A11.956 11.956 0 0112 2.714z" />
                </svg>
                <span>Ideal para agilizar la asignación inmediata de tutores y asegurar un procesamiento prioritario de tus guías de actividades.</span>
              </div>
            </div>
          </div>

          {/* Badge verde inferior */}
          <div className="mt-6 bg-emerald-50 text-emerald-700 font-extrabold text-xs p-3.5 rounded-xl border border-emerald-100/70 flex items-center gap-2">
            <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
            Procesamiento y entrega prioritaria
          </div>
        </div>

        {/* Tarjeta 2: Pago Dividido */}
        <div className="bg-white border border-blue-100 rounded-3xl p-6 md:p-8 text-left flex flex-col justify-between shadow-sm hover:shadow-md transition-shadow relative">
          <div className="space-y-5">
            {/* Header de Tarjeta */}
            <div className="flex items-center gap-3">
              <span className="w-7 h-7 rounded-full bg-blue-600 text-white font-black text-sm flex items-center justify-center shadow-sm">
                2
              </span>
              <h4 className="font-black text-blue-800 text-lg tracking-tight">
                Pago Dividido (50/50)
              </h4>
            </div>

            {/* Listado de Características */}
            <div className="space-y-3.5 text-slate-600 text-xs md:text-sm font-semibold">
              <div className="flex items-start gap-2.5">
                <svg className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                </svg>
                <span>50% de abono inicial + 50% contra entrega</span>
              </div>
              <div className="flex items-start gap-2.5 font-medium">
                <svg className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>Realizas un anticipo para iniciar la redacción y liquidas el saldo restante al momento de recibir tu trabajo finalizado.</span>
              </div>
            </div>
          </div>

          {/* Badge azul inferior */}
          <div className="mt-6 bg-blue-50 text-blue-700 font-medium text-xs p-3.5 rounded-xl border border-blue-100 flex items-start gap-2">
            <svg className="w-4 h-4 text-blue-600 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
            </svg>
            <div>
              <span className="font-black uppercase text-[10px] text-blue-800 tracking-wider block mb-0.5">Ejemplo:</span>
              Taller de 5 páginas para entregar en 3 días = Abonas el 50% para arrancar y el 50% al tenerlo listo.
            </div>
          </div>
        </div>

      </div>

      {/* 3. BLOQUE DE FLUJO LOGÍSTICO Y FILTROS */}
      <div className="bg-white border border-slate-200/60 rounded-3xl p-6 md:p-8 shadow-sm max-w-5xl mx-auto space-y-8">
        <div className="flex items-center justify-center gap-2 border-b border-slate-100 pb-4">
          <svg className="w-5 h-5 text-purple-600" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
          </svg>
          <h4 className="font-black text-slate-900 text-base md:text-lg tracking-tight">
            Flujo de Garantía y Calidad de tu Entrega
          </h4>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
          {/* Nodo 1 */}
          <div className="flex flex-col items-center space-y-2">
            <div className="w-11 h-11 rounded-full bg-purple-50 border border-purple-100 text-purple-600 flex items-center justify-center shadow-inner">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125" />
              </svg>
            </div>
            <h5 className="font-extrabold text-slate-800 text-sm md:text-base tracking-tight">Redacción Humana</h5>
            <p className="text-xs text-slate-500 font-semibold px-2 leading-relaxed">
              Desarrollado de forma 100% orgánica por un tutor experto profesional. Queda totalmente prohibido el uso de herramientas de Inteligencia Artificial.
            </p>
          </div>

          {/* Nodo 2 */}
          <div className="flex flex-col items-center space-y-2">
            <div className="w-11 h-11 rounded-full bg-emerald-50 border border-emerald-100 text-emerald-600 flex items-center justify-center shadow-inner">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751A11.956 11.956 0 0112 2.714z" />
              </svg>
            </div>
            <h5 className="font-extrabold text-slate-800 text-sm md:text-base tracking-tight">Cero Plagio (Turnitin)</h5>
            <p className="text-xs text-slate-500 font-semibold px-2 leading-relaxed">
              Sometemos cada archivo a un riguroso escaneo de originalidad mediante la plataforma Turnitin Premium antes de realizar el despacho final.
            </p>
          </div>

          {/* Nodo 3 */}
          <div className="flex flex-col items-center space-y-2">
            <div className="w-11 h-11 rounded-full bg-blue-50 border border-blue-100 text-blue-600 flex items-center justify-center shadow-inner">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
              </svg>
            </div>
            <h5 className="font-extrabold text-slate-800 text-sm md:text-base tracking-tight">Periodo de Ajustes</h5>
            <p className="text-xs text-slate-500 font-semibold px-2 leading-relaxed">
              Dispones de hasta siete (7) días calendario posteriores a la entrega para solicitar correcciones gratuitas alineadas a la rúbrica inicial.
            </p>
          </div>
        </div>


      </div>

    </div>
  );
};
const condicionesTrabajos = [
  {
    num: "1",
    title: "Plazo de Ajustes Gratuitos",
    desc: "Dispones de un tiempo establecido tras la entrega formal para solicitar revisiones o correcciones basadas en los parámetros acordados.",
    alert: "Hasta siete (7) días calendario de revisiones totalmente gratuitas.",
    theme: "bg-blue-50 border-blue-100 text-blue-800",
    circle: "bg-blue-500",
    alertBox: "bg-blue-100/50 border-blue-200 text-blue-700"
  },
  {
    num: "2",
    title: "Excepciones de Garantía de Ajustes",
    desc: "No aplican revisiones gratuitas si surgen adiciones de temas no pactados o si modificas los requerimientos iniciales de forma unilateral.",
    alert: "Cambios de última hora en la rúbrica por el docente o el cliente anulan la gratuidad.",
    theme: "bg-orange-50 border-orange-100 text-orange-800",
    circle: "bg-orange-500",
    alertBox: "bg-orange-100/50 border-orange-200 text-orange-700"
  },
  {
    num: "3",
    title: "Retrasos por Información Incompleta o Demoras",
    desc: "Si no proporcionas oportunamente aclaraciones, guías de lectura complementarias o contraseñas de plataformas.",
    alert: "El plazo de entrega se suspende temporalmente sin constituir un fallo de entrega.",
    theme: "bg-amber-50 border-amber-100 text-amber-800",
    circle: "bg-amber-500",
    alertBox: "bg-amber-100/50 border-amber-200 text-amber-700"
  },
  {
    num: "4",
    title: "Garantía por Nota Reprobatoria Justificada",
    desc: "En el caso excepcional de obtener una nota no aprobatoria, se debe adjuntar el soporte oficial junto a la retroalimentación del docente.",
    alert: "Plazo máximo de quince (15) días para solicitar reembolso proporcional, total o saldo a favor.",
    theme: "bg-red-50 border-red-100 text-red-800",
    circle: "bg-red-500",
    alertBox: "bg-red-100/50 border-red-200 text-red-700"
  }
];

//GLOBAL
const CondicionesGlobal = ({ condiciones }) => {
  return (
    <div className="space-y-8 animate-fadeIn">
      
      {/* Títulos de Sección */}
      <div className="text-center mb-12">
        <h3 className="text-2xl md:text-3xl font-black text-slate-900">
          Condiciones de Exámenes
        </h3>
        <p className="text-slate-500 text-sm md:text-base mt-2 font-medium">
          Para garantizar la calidad y el cumplimiento en nuestros servicios
        </p>
      </div>

      {/* Listado de Tarjetas de Condiciones */}
      <div className="max-w-5xl mx-auto space-y-4">
        {condiciones.map((item, index) => (
          <div 
            key={index} 
            className={`flex flex-col md:flex-row gap-5 p-6 md:p-8 rounded-[2rem] border transition-all hover:shadow-sm ${item.theme}`}
          >
            {/* Círculo con Número */}
            <div className={`w-10 h-10 rounded-full text-white font-black text-sm flex items-center justify-center flex-shrink-0 shadow-md ${item.circle}`}>
              {item.num}
            </div>

            {/* Contenido de Texto */}
            <div className="flex flex-col gap-4 w-full">
              <div className="text-left">
                <h4 className="font-black text-base md:text-lg tracking-tight">
                  {item.title}
                </h4>
                <p className="text-xs md:text-sm font-semibold opacity-80 mt-1">
                  {item.desc}
                </p>
              </div>

              {/* Alert Box Interno */}
              <div className={`flex items-center gap-3 p-3.5 rounded-2xl border font-bold text-xs md:text-sm ${item.alertBox}`}>
                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                </svg>
                {item.alert}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Banner Inferior de Ayuda / CTA (Fondo Degradado) */}
      <div className="max-w-5xl mx-auto mt-12">
        <div className="bg-gradient-to-r from-purple-600 to-blue-600 rounded-[2rem] p-8 md:p-12 text-white shadow-xl relative overflow-hidden group text-center">
          {/* Decoración de fondo */}
          <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-white/10 rounded-full blur-2xl group-hover:bg-white/20 transition-all" />
          
          <div className="relative z-10 space-y-6">
            <div className="space-y-2">
              <h4 className="text-xl md:text-3xl font-black tracking-tight">
                ¿Tienes alguna duda?
              </h4>
              <p className="text-white/80 text-sm md:text-base font-medium">
                Comunícate con nosotros para resolver cualquier inconveniente
              </p>
            </div>

            <div className="flex justify-center">
              <a 
                href="https://wa.me/573161585420" 
                target="_blank" 
                rel="noreferrer"
                className="bg-white text-blue-600 hover:bg-slate-50 font-black text-xs md:text-sm px-10 py-3.5 rounded-xl shadow-lg transition-all transform hover:-translate-y-1"
              >
                Contactar Ahora
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};


//ROUTING PRINCIPAL
const Taller = () => {
  const { slug } = useParams();

  //EXAMENES
  const listaDeExamenesRealizados = [
    {
      title: "Examen de Cálculo I",
      university: "Universidad Nacional",
      modality: "Presencial",
      rating: "4.8",
      date: "Mayo 2024",
      country: "Colombia",
      imgUrl: "https://dufyasesorias.com/wp-content/uploads/2026/06/Screenshot_2025-07-23-14-12-27-468_com.whatsapp.w4b-1-scaled.jpg",
      fileUrl: "https://dufyasesorias.com/wp-content/uploads/2026/06/CASO-SEMANA-2.pdf"
    },
    {
      title: "Parcial de Física Mecánica",
      university: "UNAL",
      modality: "Virtual",
      rating: "4.9",
      date: "Abril 2024",
      country: "Colombia",
      imgUrl: "https://dufyasesorias.com/wp-content/uploads/2026/06/Screenshot_2025-07-23-14-12-27-468_com.whatsapp.w4b-1-scaled.jpg",
      fileUrl: "https://dufyasesorias.com/wp-content/uploads/2026/06/CASO-SEMANA-2.pdf"
    },
    {
      title: "Examen de Química Orgánica",
      university: "UdeA",
      modality: "Mixto",
      rating: "4.7",
      date: "Marzo 2024",
      country: "Colombia",
      imgUrl: "https://dufyasesorias.com/wp-content/uploads/2026/06/Screenshot_2025-07-23-14-12-27-468_com.whatsapp.w4b-1-scaled.jpg",
      fileUrl: "https://dufyasesorias.com/wp-content/uploads/2026/06/CASO-SEMANA-2.pdf"
    }
  ];
  const listaTestimoniosParciales = [
    {
      name: "Estudiante A***",
      university: "Universidad Nacional",
      subject: "Cálculo Diferencial",
      review: "Excelente servicio, muy profesionales y discretos. Obtuve la calificación que necesitaba."
    },
    {
      name: "Cliente M***",
      university: "UNAL",
      subject: "Física I",
      review: "Cumplieron con todo lo prometido. El tutor fue muy claro y resolvió todas mis dudas."
    }
  ];

  //TALLERES
  const listaDeTalleresRealizados = [

  ];
  const listaTestimoniosTalleres = [

  ];

  // Mapeamos qué grupo de widgets inyectarle al cascarón según la URL
  if (slug === "examenes-parciales") {
    return (
      <ServiceDashboard 
        serviceTitle="Parciales Académicos"
        serviceDescription="Profesionales especializados te ayudan con tus exámenes parciales en tiempo real. Metodología probada, resultados garantizados."
        videoUrl="https://dufyasesorias.com/wp-content/uploads/2026/06/examenes-confiianza-3.mp4"
        tabsWidgets={{
          metodologia: (
            <div className="space-y-8">
              <MetodologiaParciales />
              <GarantiaWidget />
            </div>
          ),
          condiciones: <CondicionesGlobal condiciones={condicionesParciales} />,
          examenes: <Pruebas pruebasList={listaDeExamenesRealizados} />,
          testimonios: <Testimonios testimoniosList={listaTestimoniosParciales} />
        }}
      />
    );
  }

  else if (slug === "talleres-academicos"){
    return(
      <ServiceDashboard 
        serviceTitle="Talleres academicos"
        serviceDescription="Desarrollo detallado paso a paso de tus guías, laboratorios e informes por profesionales expertos. Garantizamos el rigor conceptual y el cumplimiento estricto de tu rúbrica de evaluación"
        videoUrl="https://dufyasesorias.com/wp-content/uploads/2026/06/trabajos-confianza-4.mp4"
        tabsWidgets={{
          metodologia: (
            <div className="space-y-8">
              <MetodologiaTrabajos />
              <GarantiaWidget />
            </div>
          ),
          condiciones: <CondicionesGlobal condiciones={condicionesTrabajos} />,
          examenes: <Pruebas pruebasList={listaDeTalleresRealizados} />,
          testimonios: <Testimonios testimoniosList={listaTestimoniosTalleres} />
        }}
      />
    )
  }

  else if (slug === "trabajos-de-grado"){

  }

  else if (slug === "revision-turnitin"){

  }

  else if (slug === "asesorias-personalizada"){

  }

  else if (slug === "manejo-plataformas"){

  }

  // Fallback si entran a un servicio que aún estás programando
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center">
      <h2 className="text-xl font-bold text-slate-800">Cargando Módulos Especializados...</h2>
      <Link to="/" className="text-blue-600 font-bold text-xs mt-4">Regresar</Link>
    </div>
  );
};

export default Taller;